// export const mainBaseUrl = 'http://localhost:5173/';
// export const apiBaseUrl = 'http://localhost/my_projects/InfluencerWeb/backend/';
export const mainBaseUrl = "https://app.inflorix.com/";
export const apiBaseUrl = 'https://api.inflorix.com/';

